// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.counter-section {
  background: #e02362;
  padding: 60px 0;
  overflow: hidden;
  position: relative;
}
.counter-section .container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 15px;
}
.counter-section .row {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.counter-section .counter-item {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 22.5px);
  padding: 20px;
  text-align: center;
}
@media (max-width: 1200px) {
  .counter-section .counter-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 15px);
  }
}
@media (max-width: 768px) {
  .counter-section .counter-item {
    flex: 0 0 100%;
  }
}
.counter-section .counter-item .counter .counter-value {
  font-size: 48px;
  font-weight: 700;
  color: white;
  margin: 0 0 10px 0;
  line-height: 1;
}
@media (max-width: 768px) {
  .counter-section .counter-item .counter .counter-value {
    font-size: 36px;
  }
}
.counter-section .counter-item .counter .counter-label {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}
@media (max-width: 768px) {
  .counter-section .counter-item .counter .counter-label {
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  .counter-section {
    padding: 40px 0;
  }
  .counter-section .counter-item .counter .counter-value {
    font-size: 32px;
  }
  .counter-section .counter-item .counter .counter-label {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/counter.scss"],"names":[],"mappings":"AAGA;EACE,mBAHgB;EAIhB,eAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAIE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAFJ;AAKE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAHJ;AAME;EACE,YAAA;EAAA,cAAA;EAAA,8BAAA;EACA,aAAA;EACA,kBAAA;AAJJ;AAMI;EALF;IAMI,YAAA;IAAA,cAAA;IAAA,4BAAA;EAHJ;AACF;AAKI;EATF;IAUI,cAAA;EAFJ;AACF;AAKM;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAHR;AAKQ;EAPF;IAQI,eAAA;EAFR;AACF;AAKM;EACE,eAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAHR;AAKQ;EARF;IASI,eAAA;EAFR;AACF;;AAQA;EACE;IACE,eAAA;EALF;EASM;IACE,eAAA;EAPR;EAUM;IACE,eAAA;EARR;AACF","sourcesContent":["$primary-color: #70b60a;\n$secondary-color: #e02362;\n\n.counter-section {\n  background: $secondary-color;\n  padding: 60px 0;\n  overflow: hidden;\n  position: relative;\n\n  .container {\n    max-width: 1140px;\n    margin: 0 auto;\n    padding: 0 15px;\n  }\n\n  .row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 30px;\n  }\n\n  .counter-item {\n    flex: 0 0 calc(25% - 22.5px);\n    padding: 20px;\n    text-align: center;\n\n    @media (max-width: 1200px) {\n      flex: 0 0 calc(50% - 15px);\n    }\n\n    @media (max-width: 768px) {\n      flex: 0 0 100%;\n    }\n\n    .counter {\n      .counter-value {\n        font-size: 48px;\n        font-weight: 700;\n        color: white;\n        margin: 0 0 10px 0;\n        line-height: 1;\n\n        @media (max-width: 768px) {\n          font-size: 36px;\n        }\n      }\n\n      .counter-label {\n        font-size: 16px;\n        color: rgba(255, 255, 255, 0.9);\n        margin: 0;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n\n        @media (max-width: 768px) {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .counter-section {\n    padding: 40px 0;\n\n    .counter-item {\n      .counter {\n        .counter-value {\n          font-size: 32px;\n        }\n\n        .counter-label {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
